/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { Field } from './Field.js';
import {
    FieldFromJSON,
    FieldFromJSONTyped,
    FieldToJSON,
} from './Field.js';

/**
 * 
 * @export
 * @interface Step
 */
export interface Step {
    /**
     * 
     * @type {number}
     * @memberof Step
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof Step
     */
    heading?: string;
    /**
     * 
     * @type {string}
     * @memberof Step
     */
    content?: string;
    /**
     * 
     * @type {Array<Field>}
     * @memberof Step
     */
    fields?: Array<Field>;
}

/**
 * Check if a given object implements the Step interface.
 */
export function instanceOfStep(value: object): boolean {
    return true;
}

export function StepFromJSON(json: any): Step {
    return StepFromJSONTyped(json, false);
}

export function StepFromJSONTyped(json: any, ignoreDiscriminator: boolean): Step {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'heading': json['heading'] == null ? undefined : json['heading'],
        'content': json['content'] == null ? undefined : json['content'],
        'fields': json['fields'] == null ? undefined : ((json['fields'] as Array<any>).map(FieldFromJSON)),
    };
}

export function StepToJSON(value?: Step | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'heading': value['heading'],
        'content': value['content'],
        'fields': value['fields'] == null ? undefined : ((value['fields'] as Array<any>).map(FieldToJSON)),
    };
}

